import SettingsContext from "../SettingsContextAdmin";
import { useContext } from "react";

const useSettingsAdmin = () => useContext(SettingsContext);

export default useSettingsAdmin;  
